import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MaintenanceOrderResponse } from '../../../models/maintenance-order-response.model';
import { Equipment } from '../../../models/equipment.model';
import { TotalCost } from '../../../models/total-cost-model';
import { MaintenanceOrderLineItem } from '../../../models/maintenance-order-line-item';
import { MaintenanceOrderRemark } from '../../../models/maintenance-order-remark.model';
import { getTPIChar } from '../../../models/tpi.model';
import { utils } from '../../../helper/utils';

@Component({
  selector: 'app-print-work-order',
  standalone: true,
  imports: [CommonModule, DatePipe],
  templateUrl: './print-work-order.component.html',
  styleUrl: './print-work-order.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PrintWorkOrderComponent {
  @Input() workOrder!: MaintenanceOrderResponse | null;
  @Input() equipment!: Equipment | null;
  @Input() totalCost!: TotalCost;
  @Input() gensetHours!: number | null;
  @Input() workOrderId!: string;
  @Input() workOrderStatus!: string;
  @Input() totalManHoursSummary!: number;
  @Input() includeRemarks = true;

  today = new Date();

  getTPICode(indicator: string): string {
    return getTPIChar(indicator);
  }

  getItemTotal(item: MaintenanceOrderLineItem): number {
    const partTotal = item.maintenanceOrderParts?.reduce((sum, p) => sum + p.unitPrice * p.unitQuantity, 0) ?? 0;
    return utils.formatNumberToTwoDigitDecimal(item.repairQuantity * item.materialCostPerPiece + partTotal);
  }

  getRemarkLabel(remark: MaintenanceOrderRemark): 'SYSTEM' | 'EXTERNAL' | 'INTERNAL' {
    if (remark.maintenanceOrderRemarkType === 'S') return 'SYSTEM';
    if (remark.maintenanceOrderRemarkType === 'E') return 'EXTERNAL';
    return 'INTERNAL';
  }

  getEquipmentSize(): string {
    if (!this.equipment?.equipmentSize) return '-';
    const size = this.equipment.equipmentSize.toString();
    return this.equipment.outsideHeight ? `${size}/${this.equipment.outsideHeight}` : `${size}/-`;
  }

  getWearAndTearCostLocal(): number {
    if (!this.totalCost) return 0;
    return utils.formatNumberToTwoDigitDecimal(
      this.totalCost.lineItems.filter((i) => i.thirdPartyIndicator === 'WEAR_AND_TEAR').reduce((sum, i) => sum + i.totalMaterialCost, 0),
    );
  }

  getWearAndTearCostUsd(): number {
    return utils.formatNumberToTwoDigitDecimal(this.getWearAndTearCostLocal() * (this.totalCost?.shopExchangeRateToUsd ?? 1));
  }

  getThirdPartyCostLocal(): number {
    if (!this.totalCost) return 0;
    return utils.formatNumberToTwoDigitDecimal(
      this.totalCost.lineItems.filter((i) => i.thirdPartyIndicator === 'THIRD_PARTY').reduce((sum, i) => sum + i.totalMaterialCost, 0),
    );
  }

  getThirdPartyCostUsd(): number {
    return utils.formatNumberToTwoDigitDecimal(this.getThirdPartyCostLocal() * (this.totalCost?.shopExchangeRateToUsd ?? 1));
  }
  mapDamageCode(damageCode: number | null | undefined): string {
    switch (damageCode) {
      case 1:
        return 'Total Loss';
      case 2:
        return 'Damaged Box';
      case 3:
        return 'Damaged Reefer Box + Reefer Unit';
      case 4:
        return 'Damaged Reefer Unit';
      default:
        return 'No Damage/Sound Condition';
    }
  }
}
